<template>
  <div
    class="home"
    @touchstart.stop="handleTouchstart"
    @touchend.stop="handleTouchend"
    @touchmove.stop="handleTouchMove"
  >
    <template v-if="videoList.length > 0">
      <player
        :theatreDetail="videoDetail"
        :videoDetail="videoList[currentIndex]"
        :os="os"
        :episode="videoList[currentIndex].episode"
        class="player"
        :videoSrc="videoSrc"
        @endPlay="endPlay"
        @pausePlay="pausePlay"
        @onPlaying="onPlaying"
        @showListPop="showListPop"
        @reportPlaying="reportPlaying"
        ref="players"
      ></player
    ></template>
    <ZyBack :isShowText="isShowText" @onBack="onBack" />
    <!-- 选集浮层 -->
    <PopVideoList
      v-if="showPopVideoList"
      :episode="videoList[currentIndex].episode"
      :video-detail="videoDetail"
      :show-pop="showPopVideoList"
      :video-list="videoList"
      :is-tab-page="false"
      @closePop="showPopVideoList = false"
      @openRechargePop="openRechargePop"
      @unlockVideo="unlockVideo"
      @changeVideo="changeVideo"
    />
    <zyRechargePop
      v-if="isShowRechargePop"
      @paySuccess="paySuccess"
      @payFail="payFail"
      @close="closeRechargePop"
    ></zyRechargePop>
    <!-- <div @click="clickRecharge">点击付费</div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import player from '@/components/player/index'
import zyRechargePop from '../components/zy-recharge-pop/index'
import appConfig from '../common/appConfig'
// @ is an alias to /src
import { getVideoDetail, getVideoListNew, unlockEpisode } from '@/apis/video.js'
import { getJsSDKParams } from '@/apis'
import PopVideoList from '@/components/pop-video-list/index.vue'
import { localGet, localSet } from '../common/storage'
import ZyBack from '../components/zy-back/index'

export default {
  name: 'Home',
  components: {
    player,
    zyRechargePop,
    PopVideoList,
    ZyBack
  },
  computed: {
    ...mapGetters(['userInfo', 'referer', 'currentPage','appInit'])
  },
  data() {
    return {
      os: 'android',
      list: [1, 2, 3],
      startY: 0,
      showPopVideoList: false,
      swiperIndex: 0,
      videoList: [],
      videoDetail: null,
      currentIndex: 0,
      isShowRechargePop: false,
      lockObject: null,
      lastChangeTime: 0,
      isShowText: true,
    }
  },
  async created() {
    if (!this.appInit) {
      await this.$store.dispatch('common/initSDK')

    }
    this.getDeviceInfo()
    console.log('router===>', this.$route)
    this.getData()
    console.log('[created]===>', this.$refs)
  },
  methods: {
    reportPlaying(firstCanplaythrough) {
      REPORT_SDK.report({
        event_id: 'player_start_playing',
        event_name: '短剧开始播放',
        referer: this.currentPage,
        scene: this.videoList[this.currentIndex].is_cost == 1 ? '付费剧集' : '免费剧集',
        page_name: String(this.videoList[this.currentIndex].episode),
        page_url: String(this.$route.query.video_id)
      })
    },
    getDeviceInfo() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        console.log('ios')
        this.os = 'ios'
      }
      if (/(Android)/i.test(navigator.userAgent)) {
        //android
        console.log('我是android')
        this.os = 'android'
        this.isShowText = false
      }
    },
    async initWxSDK() {
      const data = await getJsSDKParams({
        url: this.$route.path
      })
      this.$wx.config({
        debug: false, // true是开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.app_id, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，签名的时间戳，后台生成的
        nonceStr: data.nonce_str, // 必填，签名的随机串，后台生成的
        signature: data.signature, // 必填，签名，后台生成的
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，scanQRCode是调用扫一扫二维码
      })
      this.$wx.ready(() => {
        console.log('wx-ready')
        if (this.os == 'ios') {
          this.$refs.players && this.$refs.players.initPlay()
        }
        REPORT_SDK.report({
          event_id: 'player_page_show',
          event_name: '播放-播放首页',
          referer: this.referer,
          page_type: String(this.videoList[this.currentIndex].episode)
        })
        // config信息验证后会执行 ready 方法，所有接口调用都必须在 config 接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在 ready 函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在 ready 函数中。
      })
      this.$wx.error((res) => {
        console.log('error', res)
        // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
      })
    },
    async getData() {
      const episode = Number(this.$route.query.episode || 1)
      try {
        const detailRes = await getVideoDetail({
          video_id: Number(this.$route.query.video_id),
          filter_copyright_category: [1, 2],
          episode
        })
        const listRes = await getVideoListNew({
          video_id: Number(this.$route.query.video_id),
          filter_copyright_category: [1, 2],
          episode
        })
        this.videoDetail = detailRes
        if (listRes.video_status != 2000) {
          this.$toast.show('此剧已下架，请返回企微观看其它短剧', 3000)
        }
        this.$store.commit('common/SET_CURRENTVIDEOID', Number(this.$route.query.video_id))
        this.videoList = listRes.video_episode_info || []
        const idx = this.videoList.findIndex((e) => e.episode == episode)
        this.videoSrc = this.videoList[idx].play_url
        this.currentIndex = idx
        this.initWxSDK()
        // this.$refs.players.changeSrc(this.videoList[idx].play_url)
      } catch (err) {
        console.log('getData-err', err)
        this.$toast.show('网络异常，请退出重试', 3000)
      }
    },
    handleTouchstart(event) {
      this.startY = event.changedTouches[0].clientY
    },
    handleTouchMove(event) {
      event.preventDefault()
    },
    //手指离开屏幕
    handleTouchend(event) {
      const endY = event.changedTouches[0].clientY
      this.transY = 0
      const dis = endY - this.startY
      this.startY = 0
      if (dis > 100 || dis < -100) {
        REPORT_SDK.report({
          event_id: 'player_page_click',
          event_name: '播放-播放首页点击',
          referer: this.referer,
          page_type: String(this.videoList[this.currentIndex].episode),
          element_name: '上下划动'
        })
      }
      //下拉，切上一集
      if (dis > 100) {
        if (new Date().getTime() - this.lastChangeTime <= 1500) {
          return
        }
        this.lastChangeTime = new Date().getTime()
        if (this.currentIndex <= 0) {
          this.$toast.show('已经是第一集啦', 2000)
        } else {
          this.changeVideo(this.videoList[this.currentIndex - 1])
        }
      }
      //上划,切下一级
      if (dis < -100) {
        if (new Date().getTime() - this.lastChangeTime <= 1500) {
          return
        }
        this.lastChangeTime = new Date().getTime()
        if (this.currentIndex >= this.videoList.length) {
          this.isShowText = false
          this.$toast.show('已经是最后一集啦', 2000)
        } else {
          this.changeVideo(this.videoList[this.currentIndex + 1])
        }
      }
    },
    showListPop() {
      this.showPopVideoList = true
      REPORT_SDK.report({
        event_id: 'player_page_click',
        event_name: '播放-播放首页点击',
        referer: this.referer,
        page_type: String(this.videoList[this.currentIndex].episode),
        element_name: '选集'
      })
    },
    openRechargePop() {
      this.isShowRechargePop = true
    },
    closeRechargePop() {
      this.isShowRechargePop = false
    },
    // 解锁剧集
    unlockVideo(e) {
      console.log('unlockVideo1111', e)
      const self = this
      this.lockObject = e
      unlockEpisode({
        video_id: e.video_id,
        episode: e.episode,
        hit_video_white_list: [],
        version: ''
      })
        .then((DATA) => {
          console.log('unlockVideo1', DATA)
          if (DATA.success) {
            // 通过video_id/episode找出对象插入video_id并标记解锁
            console.log('unlockVideo2')
            self.changeVideo(self.lockObject, DATA.play_url)
            console.log('unlockVideo3', this.$utils.get(this.userInfo, 'vip'), DATA.coin)
            if (!this.$utils.get(this.userInfo, 'vip') && DATA.coin > 0) {
              console.log('unlockVideo3')
              this.$toast.show(`本集价格${DATA.coin}金币，已解锁`, 2000)
            }
            REPORT_SDK.report({
              event_id: 'vcurrency_consumption',
              event_name: '金币消费',
              page_url: String(e.video_id),
              page_name: String(e.episode),
              scene: String(DATA.coin)
            })
            console.log('unlockVideo4')
            // 计算解锁后金币
            self.$store.dispatch('user/setUserInfo')
            this.showPopVideoList = false
          }
        })
        .catch((err) => {
          console.log('unlockVideoerr', err)
          if (this.$utils.get(err, 'data.DESC') && this.$utils.get(err, 'data.STATUS') != 1202) {
            this.$toast.show(err.data.DESC, 2000)
          }
          self.openRechargePop('unlockVideo')
        })
    },
    changeVideo(changeItem, url) {
      const idx = this.videoList.findIndex((e) => e.episode == changeItem.episode)
      if (url) {
        let arr = this.videoList.map((item) => {
          if (item.video_id == changeItem.video_id && item.episode == changeItem.episode) {
            item.play_url = url
            item.is_unlock = true
            return item
          }
          return item
        })
        this.videoList = arr
      }
      console.log('changeVideo', this.videoList[idx])
      if (this.videoList[idx].play_url) {
        this.currentIndex = idx
        this.$refs.players.changeSrc(this.videoList[this.currentIndex].play_url)
      } else {
        this.unlockVideo(changeItem)
      }
    },
    pausePlay() {
      this.isShowText = false
    },
    onPlaying() {
      this.isShowText = true
    },
    endPlay() {
      this.changeVideo(this.videoList[this.currentIndex + 1])
    },
    onBack() {
      console.log('返回首页===', this.$refs)
      this.$refs.players && this.$refs.players.disposePlayer()
      REPORT_SDK.report({
        event_id: 'player_page_click',
        event_name: '播放-播放首页点击',
        referer: this.referer,
        page_type: String(this.videoList[this.currentIndex].episode),
        element_name: '回到首页'
      })
    },
    paySuccess() {
      console.log('支付成功')
      this.closeRechargePop()
    },
    payFail() {
      console.log('支付失败')
    }
  }
}
</script>
<style lang="less" scoped>

body{
  height:100%;
  width: 100%;
  position:fixed;
  top:0;
  left:0;
  margin: 0;
  padding:0;
}
.home {
  position: relative;
  width: 750px;
  height: 100vh;
  // overflow-x:hidden;
}
.last-div {
  position: absolute;
  top: 0;
  height: 500px;
  width: 750px;
  background: #000;
  font-size: 32px;
  color: #eee;
  font-weight: 600;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 0;
  p {
    text-align: center;
  }
}
.next-div {
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 500px;
  width: 750px;
  background: #000;
  font-size: 32px;
  color: #eee;
  font-weight: 600;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  p {
    text-align: center;
  }
}
.last-div {
  position: absolute;
  top: -500px;
  height: 500px;
  width: 750px;
  background: #444;
}
.player {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100vh;
}
</style>
